<template>
  <div class="form-data-viewer inline-block w-full">
    <div v-if="allFields.length > 0 || (affiliations && affiliations.length > 0)">
      <b-row class="pt-1">
        <b-col cols="12">
          <div class="flex h-full border-b" style="cursor: pointer;">
            <div :class="[(currentRoute === 'entity-information') ? 'menu-item-active' : 'menu-item']" @click="select('entity-information')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Entity Information</div>
                
              </div>
            </div>
            <div v-if="addressFields.length > 0" :class="[(currentRoute === 'address') ? 'menu-item-active' : 'menu-item']" @click="select('address')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Address</div>
               
              </div>
            </div>
            <div v-if="contactFields.length > 0" :class="[(currentRoute === 'contact') ? 'menu-item-active' : 'menu-item']" @click="select('contact')">
               <div class="flex mt-6">
                <div style="font-size: 14px">Contact Information</div>
               
              </div>
            </div>
            <div v-if="individualsFields.length > 0" :class="[(currentRoute === 'individuals') ? 'menu-item-active' : 'menu-item']" @click="select('individuals')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Members</div>
                <b-badge class="bg-blue mb-1 mx-1">{{ individualsCount }}</b-badge>
              </div>
            </div>
            <div v-if="associatesFields.length > 0" :class="[(currentRoute === 'associates') ? 'menu-item-active' : 'menu-item']" @click="select('associates')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Associates</div>
                <b-badge class="bg-blue mb-1 mx-1">{{ associatesCount }}</b-badge>
              </div>
            </div>
            <div v-if="representativesFields.length > 0" :class="[(currentRoute === 'representatives') ? 'menu-item-active' : 'menu-item']" @click="select('representatives')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Representatives</div>
                <b-badge class="bg-blue mb-1 mx-1">{{ representativesCount }}</b-badge>
              </div>
            </div>
            <div v-if="beneficialOwnersFields.length > 0" :class="[(currentRoute === 'beneficial-owners') ? 'menu-item-active' : 'menu-item']" @click="select('beneficial-owners')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Beneficial Owners</div>
                <b-badge class="bg-blue mb-1 mx-1">{{ beneficialOwnersCount }}</b-badge>
              </div>
            </div>
            <div v-if="affiliations && affiliations.length > 0" :class="[(currentRoute === 'affiliations') ? 'menu-item-active' : 'menu-item']" @click="select('affiliations')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Affiliations</div>
                <b-badge class="bg-blue mb-1 mx-1">{{ affiliations.length }}</b-badge>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col cols="12">
          <div class="pl-6 pb-6 space-y-5" v-if="currentRoute !== 'affiliations'">
            <div
                v-for="(fieldData) in activeFields"
                :key="fieldData.field.id"
                class="space-y-1"
            >
            
              <b-form-group
                  v-if="isTextType(fieldData.field.type)"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    :type="fieldData.field.type === 'email' ? 'email' : fieldData.field.type === 'number' ? 'number' : 'text'"
                    disabled="true"
                    :value="getFieldValue(fieldData.field.id)"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'textarea' || fieldData.field.type === 'long_text'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-textarea
                    class="form-text text-sm noFocus"
                    disabled="true"
                    rows="3"
                    :value="getFieldValue(fieldData.field.id)"
                    required>
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'select' || fieldData.field.type === 'dropdown'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="getOptionLabel(fieldData.field, getFieldValue(fieldData.field.id)) || getFieldValue(fieldData.field.id) || '—'"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'date'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="getFieldValue(fieldData.field.id)"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'checkbox' || fieldData.field.type === 'boolean'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="formatCheckboxValue(fieldData.field.id)"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'radio'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="getFieldValue(fieldData.field.id) || '—'"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'postal-address'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <PostalAddressView
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'admin-units'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <AdminUnitsView
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'isic'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <NatureOfBusinessISICView
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'contact'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <ContactView
                    :data="getObjFieldValue(fieldData.field.id)"
                />
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'country'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <CountryView
                    :data="getFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'individuals' || fieldData.field.type === 'representatives' || fieldData.field.type === 'associates'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
          
                  <IndividualsView
                    :cardinality="fieldData.field.cardinality"
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

                    <b-form-group
                  v-else-if="fieldData.field.id === 'coporate_associates' || fieldData.field.type === 'corporate_associates' || fieldData.field.type === 'corporates'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <CorporatesView
                    :cardinality="fieldData.field.cardinality"
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'beneficial-owners'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <BeneficialOwnersView
                    :cardinality="fieldData.field.cardinality"
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="formatComplexValue(getFieldValue(fieldData.field.id))"
                    required>
                </b-form-input>
              </b-form-group>
            </div>
            
            <div v-if="activeFields.length === 0" class="text-center py-12">
               <p class="text-gray-500">No details available in this section.</p>
            </div>
          </div>

          <div v-if="currentRoute === 'affiliations'" class="pl-6 space-y-5">
            <table v-if="affiliations && affiliations.length > 0" class="min-w-full leading-normal mt-1 text-gray text-xs" style="border: solid 1px #dedede;">
              <thead class="bg-gray-pale">
                <tr>
                  <th class="px-3 py-2 border-b text-left">Associate Register</th>
                  <th class="px-3 py-2 border-b text-left">Type</th>
                  <th class="px-3 py-2 border-b text-left">Sub Type</th>
                  <th class="px-3 py-2 border-b text-left">Registration Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(affiliation, idx) in affiliations" :key="idx">
                  <td class="px-3 py-2 border-b">{{ affiliation.registrationInstitution }}</td>
                  <td class="px-3 py-2 border-b">{{ affiliation.type }}</td>
                  <td class="px-3 py-2 border-b">{{ affiliation.subType }}</td>
                  <td class="px-3 py-2 border-b">{{ formatDate(affiliation.registrationDate) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </b-col>
      </b-row>
    </div>

    <div v-else class="text-center py-12">
      <p class="text-gray-500">No application data to preview</p>
    </div>
  </div>
</template>

<script>
import PostalAddressView from '../../non-individual/nir/components/widgets/viewers/PostalAddressView.vue';
import AdminUnitsView from '../../non-individual/nir/components/widgets/viewers/AdminUnitsView.vue';
import NatureOfBusinessISICView from '../../non-individual/nir/components/widgets/viewers/NatureOfBusinessISICView.vue';
import ContactView from '../../non-individual/nir/components/widgets/viewers/ContactView.vue';
import CountryView from '../../non-individual/nir/components/widgets/viewers/CountryView.vue';
import IndividualsView from '../../non-individual/nir/components/widgets/viewers/IndividualsView.vue';
import BeneficialOwnersView from '../../non-individual/nir/components/widgets/viewers/BeneficialOwnersView.vue';
import CorporatesView from '../../non-individual/nir/components/widgets/viewers/CorporatesView.vue';

export default {
  name: 'RegistryFormDataViewer',
  components: {
    PostalAddressView,
    AdminUnitsView,
    NatureOfBusinessISICView,
    ContactView,
    CountryView,
    IndividualsView,
    BeneficialOwnersView,
    CorporatesView,
  },
  props: {
    formData: {
      type: Object,
      default: null,
    },
    valueData: {
      type: Array,
      default: () => [],
    },
    api: {
      type: Object,
      default: null,
    },
    affiliations: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      formDataLocal: [],
      currentRoute: 'entity-information'
    };
  },
  computed: {
    allFields() {
      if (!this.formData || !this.formData.sections) return [];
      let fields = [];
      this.formData.sections.forEach(sec => {
        if (sec.fields) {
          fields = fields.concat(sec.fields);
        }
      });
      return this.getSortedFields(fields);
    },
     individualsFields() {
      return this.allFields.filter(f => f.field.type === 'individuals');
    },
    associatesFields() {
      return this.allFields.filter(f => f.field.type === 'associates' || f.field.type === 'corporate_associates');
    },
    representativesFields() {
      return this.allFields.filter(f => f.field.type === 'representatives' || f.field.type === 'corporate_representatives');
    },
    beneficialOwnersFields() {
      return this.allFields.filter(f => f.field.type === 'beneficial-owners');
    },
    addressFields() {
      return this.allFields.filter(f => ['country', 'admin-units', 'postal-address'].includes(f.field.type));
    },
    contactFields() {
      return this.allFields.filter(f => ['contact', 'email'].includes(f.field.type) || ['official_email', 'official_phone'].includes(f.field.id));
    },
    entityInformationFields() {
      const exceptions = ['individuals', 'beneficial-owners', 'country', 'admin-units', 'postal-address', 'contact', 'email', 'associates', 'representatives', 'corporate_associates', 'corporate_representatives'];
      const idExceptions = ['official_email', 'official_phone'];
      return this.allFields.filter(f => !exceptions.includes(f.field.type) && !idExceptions.includes(f.field.id));
    },
    activeFields() {
      if (this.currentRoute === 'entity-information') return this.entityInformationFields;
      if (this.currentRoute === 'address') return this.addressFields;
      if (this.currentRoute === 'contact') return this.contactFields;
      if (this.currentRoute === 'individuals') return this.individualsFields;
      if (this.currentRoute === 'associates') return this.associatesFields;
      if (this.currentRoute === 'representatives') return this.representativesFields;
      if (this.currentRoute === 'beneficial-owners') return this.beneficialOwnersFields;
      return [];
    },
    individualsCount() {
      let count = 0;
      this.individualsFields.forEach(f => {
        const val = this.getObjFieldValue(f.field.id);
        if (Array.isArray(val)) {
          count += val.length;
        } else if (val) {
          count += 1;
        }
      });
      return count;
    },
    associatesCount() {
      let count = 0;
      this.associatesFields.forEach(f => {
        const val = this.getObjFieldValue(f.field.id);
        if (Array.isArray(val)) {
          count += val.length;
        } else if (val) {
          count += 1;
        }
      });
      return count;
    },
    representativesCount() {
      let count = 0;
      this.representativesFields.forEach(f => {
        const val = this.getObjFieldValue(f.field.id);
        if (Array.isArray(val)) {
          count += val.length;
        } else if (val) {
          count += 1;
        }
      });
      return count;
    },

    beneficialOwnersCount() {
      let count = 0;
      this.beneficialOwnersFields.forEach(f => {
        const val = this.getObjFieldValue(f.field.id);
        if (Array.isArray(val)) {
          count += val.length;
        } else if (val) {
          count += 1;
        }
      });
      return count;
    }
  },
  watch: {
    valueData: {
      handler() {
        this.prefillFormData();
      },
      deep: true,
    },
  },
  mounted() {
    this.prefillFormData();
  },
  methods: {
    select(route) {
      this.currentRoute = route;
    },
    formatDate(dateStr) {
      if (!dateStr) return '—';
      return new Date(dateStr).toLocaleString();
    },
    isTextType(type) {
      return type === 'text' || type === 'email' || type === 'number';
    },
    prefillFormData() {
      if (!this.valueData || !Array.isArray(this.valueData)) return;
      const map = {};
      this.valueData.forEach(function (step) {
        if (step.data && Array.isArray(step.data)) {
          step.data.forEach(function (item) {
            map[item.fieldId] = { fieldId: item.fieldId, fieldName: item.fieldName, value: item.value };
          });
        }
      });
      this.formDataLocal = Object.keys(map).map(function (k) { return map[k]; });
    },
    getFieldValue(fieldId) {
      const entry = this.formDataLocal.find(function (item) { return item.fieldId === fieldId; });
      return entry != null ? entry.value : '';
    },
    getObjFieldValue(fieldId) {
      return this.getFieldValue(fieldId);
    },
    getSortedFields(fields) {
      if (!fields) return [];
      return [...fields].sort(function (a, b) {
        const posA = (a.field && a.field.position) != null ? a.field.position : a.position;
        const posB = (b.field && b.field.position) != null ? b.field.position : b.position;
        return (posA || 0) - (posB || 0);
      });
    },
    getSortedOptions(options) {
      if (!options || !Array.isArray(options)) return [];
      return options.filter(function (opt) { return opt.isActive !== false; }).sort(function (a, b) { return (a.position || 0) - (b.position || 0); });
    },
    getOptionLabel(field, value) {
      const opts = this.getSortedOptions(field.options || []);
      const opt = opts.find(function (o) { return o.value === value; });
      return opt ? opt.label : null;
    },
    formatCheckboxValue(fieldId) {
      const v = this.getFieldValue(fieldId);
      if (Array.isArray(v)) return v.length ? v.join(', ') : '—';
      if (v === true || v === 'true') return 'Yes';
      if (v === false || v === 'false') return 'No';
      return v != null && v !== '' ? String(v) : '—';
    },
    formatComplexValue(value) {
      if (value == null || value === '') return '—';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    },
  },
};
</script>

<style scoped>
.form-data-viewer {
  background: white;
}
.menu-item {
  color: #6b7280;
  padding: 0.5rem 1rem;
  font-weight: 500;
  border-bottom: 2px solid transparent;
}
.menu-item:hover {
  color: #374151;
  border-bottom: 2px solid #d1d5db;
}
.menu-item-active {
  color: #157EC2;
  padding: 0.5rem 1rem;
  font-weight: 500;
  border-bottom: 2px solid #157EC2;
}
.space-y-8 > * + * { margin-top: 2rem; }
.space-y-5 > * + * { margin-top: 1.25rem; }
.space-y-4 > * + * { margin-top: 1rem; }
.space-y-2 > * + * { margin-top: 0.5rem; }
.pl-6 { padding-left: 1.5rem; }
.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
</style>
